import { Component, OnInit, HostBinding } from '@angular/core';
import { IndexService } from '../index.service';
import { ProjectService, ElementsService } from 'dbweb-core';

@Component({
	selector: 'common-banner',
	templateUrl: './banner.component.html',
	styleUrls: ['./banner.component.scss']
})
export class BannerComponent implements OnInit {
	@HostBinding('class.c-index-banner') hostClass = true;
	constructor(public svr: IndexService) {}
	ngOnInit() {}
}
